import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';
import { Session } from '../../interfaces/package/session.interface';
import { environment } from '../../../../../environments/environment.dev';

@Injectable({
    providedIn: 'root'
})
export class SessionApiService extends SessionService {
    private http = inject(HttpClient);
    private readonly baseUrl = environment.apiBaseUrl + '/sessions';

    override findAll(searchParam: any): Observable<any> {
        return this.http.get<any>(this.baseUrl, { params: searchParam });
    }

    override find(id: string): Observable<Session> {
        return this.http.get<Session>(`${this.baseUrl}/${id}`);
    }

    override findByBatchId(batchId: string): Observable<Session[]> {
        return this.http.get<Session[]>(`${this.baseUrl}/batch/${batchId}`);
    }

    override findByModuleId(moduleId: string): Observable<Session[]> {
        return this.http.get<Session[]>(`${this.baseUrl}/module/${moduleId}`);
    }

    override create(data: Partial<Session>): Observable<Session> {
        return this.http.post<Session>(this.baseUrl, data);
    }

    override update(id: string, data: Partial<Session>): Observable<Session> {
        return this.http.put<Session>(`${this.baseUrl}/${id}`, data);
    }

    override delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }
}
